import React from 'react'

function NotFound() {
    return (
        <div className='h-[50vh] flex gap-5 flex-col items-center justify-center'>
            <h1 className='text-4xl'>This Page is Under Construction.</h1>
            <h5 className='text-lg'>Please try again later.</h5>
        </div>
    )
}

export default NotFound